import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import {AuthService} from '../services/infrastructure/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Como o APP_INITIALIZER já rodou, o signal isAuthenticated tem o valor real
  if (authService.isAuthenticated()) {
    return true;
  }

  // Se falhou, redireciona para login
  // Opcional: Passar a URL de retorno para redirecionar após login
  router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
  return false;
};
